import {Injectable} from '@angular/core';
import {ActivatedRoute, ResolveStart, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import {filter, map} from 'rxjs/operators';

@Injectable()
export class TitleService {

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
    ) { }


    init() {
        this.router.events.pipe(
            filter(event => event instanceof ResolveStart),
            map(event => {
                let data = null;
                let route = event['state'].root;

                while (route) {
                    data = route.data || data;
                    route = route.firstChild;
                }

                return data;
            }),
        ).subscribe((data) => {
            if (data.title) {
                return this.titleService.setTitle(`${data.title} · Denuvo Telemetry`);
            } else {
                return this.titleService.setTitle(`Denuvo Telemetry`);
            }
        });
    }

}
